export const CORSO_STORE_ORGANIZATION_NAME = 'Corso Admin Organization';
//# sourceMappingURL=corsoStoreOrganization.js.map